function data(element: any, config: any = {}) {
    //
}

// ----------------------------------------------------------------------------

export { data };
